<template>
  <div class="columns is-multiline">
    <div class="column is-full-touch is-one-quarter-desktop">
      <div class="card">
        <header class="card-header">
          <div class="media section has-text-centered is-centered">
            <figure class="image is-128x128">
              <img class="is-circle" :src="profile.imageSrc" alt="">
              <figcaption>
                <p class="title is-6">{{ profile.name }}</p>
                <p class="subtitle is-7">@{{ profile.user }}</p>
              </figcaption>
            </figure>
          </div>
        </header>
        <div class="card-content has-text-centered">
          <div class="content">
            <address>
              <strong>{{ profile.company }}</strong><br>
              <i class="fas fa-map-marker"></i>
                {{ profile.addressLine1 }}<br>
                {{ profile.addressLine2 }}<br>
              <abbr title="Phone">
                <i class="fas fa-phone"></i>
              </abbr> {{ profile.phone }}<br>
              <abbr title="Email">
                <i class="fas fa-envelope"></i>
              </abbr> {{ profile.email }}
            </address>
          </div>
        </div>
        <footer class="card-footer">
          <a href="#" class="card-footer-item">
            <i class="fas fa-phone"></i> &nbsp;Call</a>
          <a href="#" class="card-footer-item">
            <i class="fas fa-envelope"></i> &nbsp;Email</a>
          <a href="#" class="card-footer-item">
            <i class="fas fa-user-plus"></i> &nbsp;Follow</a>
        </footer>
      </div>
    </div>

    <div class="column is-full-touch is-three-quarters-desktop">
      <div class="box">
        <section class="section has-text-centered">
          <div class="title">
            <p class="title is-uppercase">Awesome developer</p>
          </div>
          <section class="section" id="work-history">
            <!-- <p class="title is-5 has-text-centered">Work history</p> -->
            <div class="columns">
              <div class="column has-text-centered">
                <i class="fas fa-calendar"></i>
                2 years of experience
              </div>
              <div class="column has-text-centered">
                <i class="fas fa-tasks"></i>
                8 projects done
              </div>
              <div class="column has-text-centered">
                <i class="fas fa-clock"></i>
                21222 hours worked
              </div>
              <div class="column has-text-centered">
                <i class="fas fa-map"></i>
                consultant in 3 countries
              </div>
            </div>
          </section>
          <p class="title is-5">About me</p>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor
            incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
            exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure
            dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
            Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt
            mollit anim id est laborum.
          </p>
        </section>

        <div class="box-content">
          <div class="columns">
            <div class="column is-half">
              <section class="section">
                <p class="title is-5">Skills</p>
                <label>Bulma</label>
                <progress class="progress is-link" value="40" max="100">40%</progress>
                <label>HTML</label>
                <progress class="progress is-primary" value="30" max="100">30%</progress>
                <label>CSS</label>
                <progress class="progress is-warning" value="50" max="100">50%</progress>
                <label>Laravel</label>
                <progress class="progress is-danger" value="90" max="100">90%</progress>
              </section>
            </div>

            <div class="column is-half">
              <section class="section">
                <p class="title is-5">Languages</p>
                <label>Romanian</label>
                <progress class="progress is-danger" value="90" max="100">90%</progress>
                <label>English</label>
                <progress class="progress is-warning" value="50" max="100">50%</progress>
                <label>Chinese</label>
                <progress class="progress is-primary" value="20" max="100">20%</progress>
              </section>
            </div>
          </div>

          <section class="section">
            <p class="title is-5 has-text-centered">Projects</p>
            <div class="columns">
              <div class="column is-half">
                <p class="has-text-centered">
                  <strong>Awesome project</strong>
                </p>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor
                  incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, proident,
                  sunt in culpa qui officia deserunt mollit anim id est laborum.
                </p>
              </div>
              <div class="column is-half">
                <p class="has-text-centered">
                  <strong>Second awesome project</strong>
                </p>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod cillum
                  dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                  sunt in culpa qui officia deserunt mollit anim id est laborum.
                </p>
              </div>
            </div>
            <div class="columns">
              <div class="column is-half">
                <p class="has-text-centered">
                  <strong>Third awesome project</strong>
                </p>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor
                  incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, proident,
                  sunt in culpa qui officia deserunt mollit anim id est laborum.
                </p>
              </div>
              <div class="column is-half">
                <p class="has-text-centered">
                  <strong>Fourth awesome project</strong>
                </p>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod cillum
                  dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                  sunt in culpa qui officia deserunt mollit anim id est laborum.
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

export default {
  data() {
    return {
      profile:
        {
          name: 'Awesome developer',
          user: 'awesomedeveloper',
          company: 'Awesome, Inc',
          addressLine1: 'Magic Street, 3/4',
          addressLine2: 'San Francisco, CA 65467',
          phone: '(123) 456-7890',
          email: 'developer@awesome.com',
          imageSrc: require('./../../../../assets/img/people/person1.jpg'),
        },

    };
  },
};
</script>

<style>
a {
  color: inherit;
}
.card {
  margin-top: 0px;
}
.is-centered {
  display: flex;
  margin-left: auto;
  margin-right: auto;
}

.card-header {
  padding-top: 1em;
  padding-bottom: 2em;
}

section.section {
  padding: 1.5rem 1.5rem;
}

.box-content section .title {
  text-transform: uppercase;
  font-weight: bold;
}

#work-history {
  padding-top: 0;
}
</style>
